import { Auth0Provider, type AppState } from '@auth0/auth0-react'
import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Auth0 SPA SDK (oficial):
 * - redirect_uri = origem da SPA
 * - cacheLocation=localstorage + refresh tokens → sessão persiste entre reloads
 * - onRedirectCallback → /account após login
 * @see https://auth0.com/docs/quickstart/spa/react
 */
export function Auth0ProviderWithNavigate({
  children,
}: {
  children: ReactNode
}) {
  const navigate = useNavigate()
  const domain = import.meta.env.VITE_AUTH0_DOMAIN
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID
  const organization = import.meta.env.VITE_AUTH0_ORGANIZATION
  const audience = import.meta.env.VITE_AUTH0_AUDIENCE
  const redirectUri =
    import.meta.env.VITE_APP_CALLBACK_URL || window.location.origin

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || '/account', { replace: true })
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        organization: organization || undefined,
        audience: audience || undefined,
        scope: 'openid profile email offline_access',
      }}
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback={false}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}
